<template>
    <div class="container-fluid">
        <Breadcrumb title="Create User" v-bind:button-show="false" v-show="!$route.params.id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit User #' + $route.params.id" v-bind:button-show="false" v-show="$route.params.id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="$route.params.id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <UserForm @hidePreloader="hidePreloader"></UserForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from '../components/Breadcrumb';
    import Preloader from '../components/Preloader';
    import UserForm from './forms/UserForm';

    export default {
        name: 'User',
        components: {Breadcrumb, Preloader, UserForm},
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        }
    }
</script>

<style scoped>

</style>